import type { AppError } from '../error/appError';

/**
 * Resultado explícito de una operación de datos.
 *
 * Las excepciones **no cruzan la frontera del repositorio**: el repositorio captura el fallo de
 * red o el código HTTP y devuelve `failure` con un `AppError` ya clasificado. Así ninguna
 * pantalla necesita `try/catch` ni conoce `fetch`.
 */
export type AppResult<T> =
  | { readonly ok: true; readonly data: T }
  | { readonly ok: false; readonly error: AppError };

export function success<T>(data: T): AppResult<T> {
  return { ok: true, data };
}

export function failure<T = never>(error: AppError): AppResult<T> {
  return { ok: false, error };
}

export function mapResult<T, R>(result: AppResult<T>, transform: (value: T) => R): AppResult<R> {
  return result.ok ? success(transform(result.data)) : result;
}

export function getOrNull<T>(result: AppResult<T>): T | null {
  return result.ok ? result.data : null;
}

export function errorOrNull<T>(result: AppResult<T>): AppError | null {
  return result.ok ? null : result.error;
}
